module.exports = __webpack_public_path__ + "img/translate_icon.07113509.png";